
import Vue from 'vue';
import AffiliatesListing from "../Portal/AffiliatesListing.vue";

export default Vue.extend({
  name: 'Home',
  props: {
  },
  components: {
    AffiliatesListing,
  },
  methods: {
  },   
  computed: {
  },
});
